module.exports = __webpack_public_path__ + "img/ampel_orange.05e568f4.svg";